export default class Color {
    static readonly ERASER = "ELASER";
    static readonly RED = "rgba(255, 0, 0, 1)";
    static readonly GREEN = "rgba(0, 255, 0, 1)";
    static readonly BLUE = "rgba(0, 0, 255, 1)";
}